/* Hathaway Point — HP home sections (editor-safe, idempotent) */
(function () {
  'use strict';
  if (window.__hpHomeJsLoaded) return;
  window.__hpHomeJsLoaded = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMarquees(scope) {
    (scope || document).querySelectorAll('[data-marquee]').forEach(function (track) {
      if (track.dataset.hpDup === '1') return;
      track.dataset.hpDup = '1';
      track.innerHTML += track.innerHTML;
    });
  }

  function initReveals(scope) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var siblings = Array.prototype.filter.call(el.parentElement.children, function (c) {
          return c.classList && c.classList.contains('rv');
        });
        var idx = siblings.indexOf(el);
        el.style.transitionDelay = Math.min(idx * 80, 400) + 'ms';
        el.classList.add('on');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    (scope || document).querySelectorAll('.rv:not(.on)').forEach(function (el) { io.observe(el); });
  }

  function initParallax(scope) {
    (scope || document).querySelectorAll('.hp-hero').forEach(function (hero) {
      if (hero.dataset.hpPar === '1') return;
      var stage = hero.querySelector('[data-parallax]');
      if (!stage || reduced || !matchMedia('(pointer: fine)').matches) return;
      hero.dataset.hpPar = '1';
      hero.addEventListener('mousemove', function (ev) {
        var r = hero.getBoundingClientRect();
        var nx = (ev.clientX - r.left) / r.width - 0.5;
        var ny = (ev.clientY - r.top) / r.height - 0.5;
        stage.querySelectorAll('.hero-tee').forEach(function (tee) {
          var d = parseFloat(tee.getAttribute('data-depth') || '15');
          tee.style.translate = (nx * -d) + 'px ' + (ny * -d) + 'px';
          tee.style.animation = 'none';
        });
      });
      hero.addEventListener('mouseleave', function () {
        stage.querySelectorAll('.hero-tee').forEach(function (tee) {
          tee.style.translate = '';
          tee.style.animation = '';
        });
      });
    });
  }

  function initHeroShuffle(scope) {
    (scope || document).querySelectorAll('.hp-hero__stage').forEach(function (stage) {
      if (stage.dataset.hpShuffle === '1') return;
      var groups = {};
      stage.querySelectorAll('.hero-tee').forEach(function (tee) {
        var g = tee.getAttribute('data-hero-group') || '0';
        (groups[g] = groups[g] || []).push(tee);
      });
      var keys = Object.keys(groups).sort();
      if (keys.length < 2) return;
      stage.dataset.hpShuffle = '1';
      var cur = 0;
      function show(i) {
        keys.forEach(function (k, idx) {
          groups[k].forEach(function (tee) { tee.classList.toggle('is-off', idx !== i); });
        });
      }
      show(0);
      setInterval(function () {
        cur = (cur + 1) % keys.length;
        show(cur);
      }, 3000);
    });
  }

  function initAll(scope) {
    initMarquees(scope);
    initReveals(scope);
    initParallax(scope);
    initHeroShuffle(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init sections when (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    e.target.querySelectorAll('.rv').forEach(function (el) { el.classList.add('on'); });
  });
})();
